var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconNews30 = function SvgAIconNews30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13C2.5 11.3431 3.84315 10 5.5 10H10.5V19H5.5C3.84315 19 2.5 17.6569 2.5 16V13Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10C10.5 10 12.5 10.1729 16.5 9C20.5 7.82707 23.5 5 23.5 5V24C23.5 24 21 21.125 16.5 20C12 18.875 10.5 19 10.5 19V10Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19V23C6.5 24.1046 7.39543 25 8.5 25V25C9.60457 25 10.5 24.1046 10.5 23V19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11V18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconNews30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0yLjUgMTNDMi41IDExLjM0MzEgMy44NDMxNSAxMCA1LjUgMTBIMTAuNVYxOUg1LjVDMy44NDMxNSAxOSAyLjUgMTcuNjU2OSAyLjUgMTZWMTNaIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTAuNSAxMEMxMC41IDEwIDEyLjUgMTAuMTcyOSAxNi41IDlDMjAuNSA3LjgyNzA3IDIzLjUgNSAyMy41IDVWMjRDMjMuNSAyNCAyMSAyMS4xMjUgMTYuNSAyMEMxMiAxOC44NzUgMTAuNSAxOSAxMC41IDE5VjEwWiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTYuNSAxOVYyM0M2LjUgMjQuMTA0NiA3LjM5NTQzIDI1IDguNSAyNVYyNUM5LjYwNDU3IDI1IDEwLjUgMjQuMTA0NiAxMC41IDIzVjE5IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMjcuNSAxMVYxOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";